import {
  EventManagementEventDTO,
  EventManagementEventItemDTO,
} from "@/common/api";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class EventModule extends VuexModule {
  public items: EventManagementEventItemDTO[] = null;
  public event: EventManagementEventDTO = null;
  public image: null;
  public config: {
    is_display_code: true;
    is_display_price: true;
    date: {
      year: null;
      month: null;
      day: null;
    };
    signature: "";
  };

  @Mutation
  public setEvent(event: EventManagementEventDTO): void {
    this.event = event;
  }

  @Action
  public updateEvent(event: EventManagementEventDTO) {
    this.context.commit("setEvent", event);
  }

  @Mutation
  public setEventItems(items: EventManagementEventItemDTO[]): void {
    this.items = items;
  }

  @Action
  public updateEventItems(items: EventManagementEventItemDTO[]) {
    this.context.commit("setEventItems", items);
  }

  @Mutation
  public setConfig(config): void {
    this.config = config;
  }

  @Action
  public updateConfig(config) {
    this.context.commit("setConfig", config);
  }

  @Mutation
  public setImage(image): void {
    this.image = image;
  }

  @Action
  public updateImage(image) {
    this.context.commit("setImage", image);
  }
}
